import { render, staticRenderFns } from "./import-area.vue?vue&type=template&id=7610250f"
import script from "./import-area.vue?vue&type=script&lang=js"
export * from "./import-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports